import React, { useEffect, useState } from 'react';

import './Stamp.single.billed.scss';
import { ProfileQL } from '../../models/Profile';
import { FiscalpopCFDI } from '../../models/Factura';
import { numberToCurrencyString } from '../../services/formatting';
import Button from '../Forms/Button';
import Loading from '../Animations/loadScreen';

import Modal from 'react-modal';
import { useMutation } from '@apollo/client';
import { graphqlSchema } from '../../services/graphql.schema';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import { RefundBinder } from '../../models/Orders';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '80vh',
        padding: '1em 2em',
        border: 'none',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)'
    }
};


function StampRefundBilled({ refundBilled, currentUser, originalUUID }: { refundBilled: RefundBinder, currentUser: ProfileQL, originalUUID: string }) {
    console.log('[StampRefundBilled] refundBilled: ', refundBilled);
    const [cfdi, setCfdi] = useState<FiscalpopCFDI>(null);

    const [cancelModalOpen, setCancelModalOpen] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [wasCancelled, setWasCancelled] = useState(false);

    const xmlLinkRef = React.createRef<HTMLAnchorElement>();
    const pdfLinkRef = React.createRef<HTMLAnchorElement>();

    const [setCancel] = useMutation(graphqlSchema.FISCALPOP.CFDI.setBillToCancel, {
        onCompleted: ({ setBillToCancel }: { setBillToCancel: { folios: { estatus: number; uuid: string }[] } }) => {
            console.log('Canceled CFDI: ', setBillToCancel);
            // Redirect user?
            setWasCancelled(true);
            sharedToasterSubject.next({ type: 'confirm', message: 'Se canceló la factura' });
        },
        onError: (e) => {
            console.error('Error canceling cfdi: ', e);
            sharedToasterSubject.next({ type: 'error', message: 'Error al cancelar la factura' });
        }
    })

    useEffect(() => {
        if (!!refundBilled && !!currentUser && !!currentUser.amazonProfile) {
            fetch(`https://api.fiscalpop.com/api/v1/cfdi/find/${currentUser.amazonProfile.authToken}/${refundBilled.uuid}`)
                .then(async response => {
                    if (response.ok) {
                        const json = await response.json();
                        return json;
                    } else {
                        const err = await response.text();
                        throw err;
                    }
                })
                .then((cfdiResponse: FiscalpopCFDI[]) => {
                    console.log('CFDI: ', cfdiResponse);
                    setCfdi(cfdiResponse[0]);
                })

        }
    }, [refundBilled, currentUser]);


    const openPdf = () => {
        pdfLinkRef.current.click();
    }
    const openXml = () => {
        xmlLinkRef.current.click();
    }

    const cancelCFDI = () => {
        setCancelModalOpen(false);
        setCancel({
            variables: {
                uuid: refundBilled.uuid
            }
        })

    }

    const renderCancelDialog = () => {
        return (
            <Modal
                isOpen={cancelModalOpen}
                onRequestClose={() => setCancelModalOpen(false)}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Cancelar Factura"
            >
                <div className="CancelWarning">
                    <h3>
                        Realmente quieres cancelar tu factura ?
                    </h3>
                    <p className="warning">{refundBilled.uuid}</p>
                    <p>
                        Este UUID quedará cancelado pero podrás volver a facturar los pedidos en otro UUID.
                    </p>
                    <div className="actions">
                        <Button primary={true} handleClick={() => setCancelModalOpen(false)}>
                            <span>Regresar</span>
                        </Button>
                        <Button accent={true} handleClick={cancelCFDI}>
                            <span>Cancelar factura</span>
                        </Button>
                    </div>
                </div>
            </Modal>
        )
    }

    const refundCfdiSwitch = () => {
        if (refundBilled.uuid === originalUUID) {
            return renderRefundIncludedCfdi()
        } else {
            return renderCfdi()
        }
    }

    const renderRefundIncludedCfdi = () => {
        return (
            <div className="cfdiInform">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" className="_inform">
                    <path d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z" />
                </svg>
                <p className="_inform">
                    Reembolso facturado
                </p>
                <div className="card _cfdiBilled">
                    <div className="_label">
                        <p className="_key">UUID:</p>
                        <p className="_value accent">La factura original incluye este reembolso, el cual no se emite como nota de credito separada</p>
                    </div>
                    <div></div>
                    <div className="_label">
                        <p className="_key">Folio</p>
                        <p className="_value">{cfdi.json['@']['Folio']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Serie</p>
                        <p className="_value">{cfdi.json['@']['Serie']}</p>
                    </div>
                </div>
            </div>
        )
    }

    const renderCfdi = () => {
        return (
            <div className="cfdiInform">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" className="_inform">
                    <path d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z" />
                </svg>
                <p className="_inform">
                    Reembolso facturado
                </p>
                <div className="card _cfdiBilled">
                    <div className="_label">
                        <p className="_key">{cfdi.status ? 'UUID:' : <span className="accent">UUID: CANCELADA </span>}</p>
                        <p className="_value accent">{cfdi.uuid}</p>
                    </div>
                    <div></div>
                    <div className="_label">
                        <p className="_key">Folio</p>
                        <p className="_value">{cfdi.json['@']['Folio']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Serie</p>
                        <p className="_value">{cfdi.json['@']['Serie']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Forma Pago</p>
                        <p className="_value">{cfdi.json['@']['FormaPago']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Lugar Expedición</p>
                        <p className="_value">{cfdi.json['@']['LugarExpedicion']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Fecha</p>
                        <p className="_value">{cfdi.json['@']['Fecha']}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Subtotal</p>
                        <p className="_value">$ {numberToCurrencyString(parseFloat(cfdi.json["@"].SubTotal))}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Descuento</p>
                        <p className="_value">$ {numberToCurrencyString(parseFloat(cfdi.json["@"]['Descuento'] || '0'))}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Total</p>
                        <p className="_value">$ {numberToCurrencyString(parseFloat(cfdi.json["@"].Total))}</p>
                    </div>
                    <div className="_label">
                        <p className="_key">Impuestos Trasladados</p>
                        <p className="_value">$ {numberToCurrencyString(parseFloat(cfdi.json["cfdi:Impuestos"]["@"].TotalImpuestosTrasladados))}</p>
                    </div>
                    <div></div>
                    <div className="_label _whole">
                        <p className="_key">Sello</p>
                        <p className="_value">{cfdi.json["@"].Sello}</p>
                    </div>
                </div>
                <div className="cfdiDownloads">
                    <div></div>
                    <div></div>
                    <div className="__links">
                        <a ref={xmlLinkRef} rel="noopener noreferrer" href={`https://api.fiscalpop.com/api/v1/cfdi/download/xml/${currentUser.amazonProfile.authToken}?uuid=${cfdi.uuid}`} download={true}>Descargar XML</a>
                        <a ref={pdfLinkRef} rel="noopener noreferrer" href={`https://api.fiscalpop.com/api/v1/cfdi/download/pdf/${currentUser.amazonProfile.authToken}?uuid=${cfdi.uuid}`} download={true}>Descargar PDF</a>
                    </div>
                    <Button secondary={true} handleClick={openXml}>
                        <span>Descargar XML</span>
                    </Button>
                    <Button primary={true} handleClick={openPdf}>
                        <span>Descargar PDF</span>
                    </Button>
                </div>
                {renderCancelDialog()}
            </div>
        )
    }

    return (
        <div id="StampSingleBilled" className="__refund">
            {
                (cfdi && currentUser.amazonProfile) ?
                    refundCfdiSwitch()
                    : <Loading display={true} />
            }
        </div>
    )
}

export default StampRefundBilled;